<div class="login-main-wrapper">
  <div class="inner-wrapper d-flex flex-column flex-lg-row">
    <div class="login-right-side flex-fill vh-100 overflow-lg-auto">
      <div class="h-100 w-100 pb-4">
        <div
          class="header border-bottom pb-4 hw-65 w-100 justify-content-between d-flex align-items-center pt-4 px-4">
          <div class="fs-18 fw-700 text-justify">Setup your account</div>
          <!-- <app-google-translate [position]="'position-static'"></app-google-translate> -->
          <div class="float pb-4 pt-4 search-bar position-relative ms-4 text-end">
            <img src="assets/images/icons/close-circle.png" style="width: 40px;" alt=""
              class="profile-icon rounded-circle border cursor" (click)="logoutModal()">

            </div>

            <!-- <div class="logout-wrapper p-4 position-absolute bg-white end-0 radius-16" *ngIf="showLogout">
            <div class="logout-header d-flex align-items-center pb-2 lhc">
              <img [src]="'assets/images/icons/profile_placeholder.png'" style="width: 40px;"
                alt="" class="business-img rounded-circle me-3 lhc">

                <div class="lhc">
                  <h1 class="fs-16 fw-600 m-0 lhc">
                    {{userProfile.doctor_name}}
                  </h1>
                  <p class="fs-14 fw-400 m-0 lhc">
                    {{userProfile.doctor_email}}
                  </p>
                </div>

              </div>

              <div class="logout-footer d-flex align-items-center pt-3 border-top mt-3">
                <img src="assets/images/icons/logout.svg" alt="" class="rounded-circle me-3 cursor" (click)="logoutModal()">
                <p class="fs-14 fw-600 m-0 cursor " (click)="logoutModal()">
                  Logout
                </p>
              </div>
            </div> -->
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center w-100 overflow-auto hide-scroll-bar"
            style="height: calc(100% - 125px);top: 40px">
            <div class="w-100 right-content p-1" style="max-width: 600px;">
              <form class="w-100" action="" (submit)="submitPracticeInfo()">
                <ng-container [formGroup]="practiceInfoForm">
                  <div class="fw-600 fs-24 mb-1">
                    Welcome, <span class="fw-800">{{userProfile && userProfile.doctor_name}}! </span>
                  </div>
                  <div class="mb-4">
                    <p class="fs-18 fw-700 mb-3">
                      Almost there—just one last step
                    </p>

                  </div>

                  <div class="form-group">
                    <label for="" class="fs-14 fw-700">Business Name</label>
                    <div class="d-flex flex-column-reverse custom-form inputContainer">
                      <input autocomplete="off" type="text" name="email" required=""
                        formControlName="practice_name" placeholder="Enter your business name"
                        class="input_field "  (blur)="trimData()">
                        <label for="text" class="label-name">
                          <!-- <span class="content-name f-c-p-3 fs-14"> Business name </span> -->
                        </label>
                      </div>
                      @if (((practiceInfoForm['controls']['practice_name'].dirty && practiceInfoForm['controls']['practice_name'].invalid ))) {
                        <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                          >
                          Please enter your valid Name.
                        </p>
                      }

                    </div>
                    <div class="col-12">
                      <div class="row">
                        <div class="col-6 form-group mt-3">
                          <label for="" class="fs-14 fw-700">Business Email Address</label>
                          <div class="d-flex flex-column-reverse custom-form inputContainer">
                            <input autocomplete="off" type="text" name="email" required=""
                              formControlName="practice_email"
                              placeholder="Enter your business email" class="input_field " (blur)="trimData()">
                              <label for="text" class="label-name">
                                <!-- <span class="content-name f-c-p-3 fs-14"> Business email </span> -->
                              </label>
                            </div>
                            @if ( ((practiceInfoForm['controls']['practice_email'].touched) && practiceInfoForm['controls']['practice_email'].invalid)) {
                              <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                                >
                                Please enter valid email address.
                              </p>
                            }
                          </div>
                          <div class="col-6 form-group mt-3">
                            <label for="" class="fs-14 fw-700">Business Phone Number</label>
                            <div
                              class="d-flex flex-column-reverse custom-form inputContainer position-relative">
                              <!-- <p class="position-absolute" style="left: 15px;top: 20px;">
                              {{(country_data && country_data.mobile_code) ? country_data.mobile_code :
                            '+1'}}</p> -->
                            <input  [mask]="mask" autocomplete="off" type="text"
                              name="email" required="" formControlName="practice_mobile"
                              placeholder="Enter your business phone number" class="input_field">
                              <label for="text" class="label-name">
                                <!-- <span class="content-name f-c-p-3 fs-14">Business phone number </span> -->
                              </label>
                            </div>

                            @if ( ((practiceInfoForm['controls']['practice_mobile'].touched ) && practiceInfoForm['controls']['practice_mobile'].invalid)) {
                              <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                                >
                              Please enter a valid Phone number </p>
                            }
                          </div>
                        </div>
                      </div>
                      <div class=" form-group mt-3">
                        <label for="" class="fs-14 fw-700">Business Website or Social Link</label>
                        <p class="fs-12 fw-500 mb-0">No website? Add your social media page instead (e.g., Facebook, Instagram, LinkedIn).</p>
                        <div class="position-relative" >
                          <input autocomplete="off" type="text" name="email" required=""
                            formControlName="web_url"
                            placeholder="www.example.com or @yourhandle" class="input_field w-100 pe-4">
                            <!-- <img src="assets/images/icons/info-circle.svg" class="hw-20 position-absolute cursor" tooltip="Don’t have a website? No problem! You can add your social media link (e.g., Facebook, Instagram, LinkedIn) instead" alt="" style="top: 20px;right: 8px;"> -->
                          </div>
                          @if ( ((practiceInfoForm['controls']['web_url'].touched) && practiceInfoForm['controls']['web_url'].invalid)) {
                            <p class="mat-error mb-0 ml-0 pl-0 fs-14 text-danger"
                              >
                              Please enter valid Website URL.
                            </p>
                          }
                        </div>
                        <div class=" form-group mt-3">
                          <label for="" class="fs-14 fw-700">Business Type</label>
                          <div class="input_field w-100 p-0 pe-2">
                            <select name="" id="" class="input_field w-100 m-0 border-0" placeholder="Business Type"
                              formControlName="practice_type">
                              <option [value]="''" disabled>Select Business Type</option>
                              <option value="Brick-and-Mortar">Brick-and-Mortar</option>
                              <option value="Online">Online</option>
                              <option value="Mobile">Mobile</option>
                            </select>
                          </div>
                          @if ( ((practiceInfoForm['controls']['practice_type'].touched || practiceInfoForm['controls']['practice_type'].dirty) && practiceInfoForm['controls']['practice_type'].invalid)) {
                            <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                              >
                            Business Type is required </p>
                          }
                        </div>
                        <div class=" justify-content-between flex-row gap-2">
                          <div class=" form-group mt-3 w-100">
                            <!-- <label for="text" class="label-name">
                            <span class="content-name f-c-p-3 fs-14">Industry </span>
                          </label> -->
                          <label for="" class="fs-14 fw-700">Industry Type</label>
                          <div class="input_field w-100 p-0 pe-2">
                            <select name="" id="" class="input_field w-100 m-0 border-0" placeholder="Industry"
                              formControlName="ind_id" (change)="getSubIndustrylist();">
                              <option [value]="''" disabled>Select Industry type</option>
                              @for (industry of industryList; track industry) {
                                <option [value]="industry.ind_id">{{
                                industry['ind_name'] }}</option>
                              }
                            </select>

                          </div>
                          @if ( ((practiceInfoForm['controls']['ind_id'].touched || practiceInfoForm['controls']['ind_id'].dirty) && practiceInfoForm['controls']['ind_id'].invalid)) {
                            <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                              >
                            Industry is required </p>
                          }
                        </div>
                        <div class=" form-group mt-3 w-100">
                          <!-- <label for="text" class="label-name">
                          <span class="content-name f-c-p-3 fs-14">Sub Industry </span>
                        </label> -->
                        <label for="" class="fs-14 fw-700">Sub Industry</label>
                        <div class="input_field w-100 p-0 pe-2">
                          <select name="" id="" class="input_field w-100 m-0 border-0" placeholder="Sub Industry"
                            formControlName="doctor_speciality" (change)="checkSubIndustry(practiceInfoForm['controls']['doctor_speciality'].value)">
                            <option [ngValue]="''" disabled>Select Sub Industry</option>
                            @for (subindustry of sub_industries; track subindustry) {
                              <option
                                [value]="subindustry.doctor_speciality">{{
                              subindustry['speciality_name'] }}</option>
                            }
                            <!-- <option *ngIf="!sub_industries.length" value="">Select Sub Industry</option> -->
                          </select>

                        </div>
                        @if ( ((practiceInfoForm['controls']['doctor_speciality'].touched || practiceInfoForm['controls']['doctor_speciality'].dirty) && practiceInfoForm['controls']['doctor_speciality'].invalid)) {
                          <p class="mat-error text-danger w-100 d-block mb-0 fs-14"
                            >
                          Sub Industry is required </p>
                        }
                      </div>
                    </div>

                    @if (practiceInfoForm.controls['ind_id'].value == 9999) {
                      <div class="form-group mt-3">
                        <div class="d-flex flex-column-reverse custom-form inputContainer">
                          <input type="text" class="input_field pt-3 px-3" required name="ind_name" (keydown)="preventLeadingSpace($event)"
                            autocomplete="none" placeholder="" trim="true" formControlName="ind_name" />
                            <label for="text" class="label-name">
                              <span class="content-name f-c-p-3 fs-14">Industry Name </span>
                            </label>
                          </div>
                          @if (practiceInfoForm.controls['ind_name'] && (practiceInfoForm.controls['ind_name'].touched && practiceInfoForm.controls['ind_name'].invalid) && !practiceInfoForm.controls['ind_name'].dirty ) {
                            <p class="mat-error mb-0 ml-0 pl-0 text-danger"
                              >
                              Please enter industry name.
                            </p>
                          }
                        </div>
                      }

                      @if (practiceInfoForm.controls['doctor_speciality'].value == 9999 ) {
                        <div class="form-group col-md-12 py-2"
                          >
                          <div class="d-flex flex-column custom-form inputContainer">
                            <label for="text" class="label-name">
                              <span class="content-name f-c-p-3">
                                Sub Industry Name
                              </span>
                            </label>
                            <input type="text" class="input_field pt-3 px-3" required (keydown)="preventLeadingSpace($event)"
                              name="doctor_speciality_name" autocomplete="none" placeholder="" trim="true"
                              formControlName="doctor_speciality_name" />
                            </div>
                            @if (practiceInfoForm.controls['doctor_speciality_name'] && (practiceInfoForm.controls['doctor_speciality_name'].touched && practiceInfoForm.controls['doctor_speciality_name'].invalid && !practiceInfoForm.controls['doctor_speciality_name'].dirty)) {
                              <p class="mat-error mb-0 ml-0 pl-0 text-danger"
                                >
                                Please
                                enter sub industry name.
                              </p>
                            }
                          </div>
                        }

                        </ng-container>

                        @if (google_id) {
                          @if (!checkBtn) {
                            <div class="consent-notice fs-14 fw-400 p-3 mt-4 cursor" role="button" tabindex="0"
                              (click)="openLegalDocuments()" (keydown.enter)="openLegalDocuments()"
                              (keydown.space)="$event.preventDefault(); openLegalDocuments()">
                              Before you continue, please review and accept the
                              <span class="fw-700">Terms &amp; Conditions</span> and
                              <span class="fw-700">Privacy Policy</span>.
                            </div>
                          } @else {
                            <p class="consent-accepted fs-14 fw-400 m-0 p-3 mt-4">
                              <span class="fw-700">{{ userProfile?.doctor_name }}</span> accepted the
                              Terms &amp; Conditions and Privacy Policy.
                            </p>
                          }
                        }

                        <button [disabled]="practiceInfoForm.invalid" class=" w-fit btn btn-secondary fw-600 mt-3"  type="submit">Continue</button>
                      </form>
                    </div>
                  </div>
                  <!-- <div class="footer d-flex border-top justify-content-end pb-4 right-padding"> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>